import type { WorkspaceProductDTO } from 'features/product/api/types/workspaceProductDTO'
import type { UserWorkspaceProductsSlice } from 'features/user/types/user'

export const mapDTOAndUpdateWorkspaceProducts = (
  apiWorkspaceProductDTO: Pick<WorkspaceProductDTO, 'product' | 'status'>,
  userWorkspaceProducts: UserWorkspaceProductsSlice[],
): UserWorkspaceProductsSlice[] => {
  const { product, status } = apiWorkspaceProductDTO

  return userWorkspaceProducts.map(
    (userWP: UserWorkspaceProductsSlice): UserWorkspaceProductsSlice =>
      userWP.product === product
        ? {
            product: userWP.product,
            status,
          }
        : userWP,
  )
}
